import React from 'react';
export function SocialProofAuthorityBox() {
  return <div className="pt-8 pb-2 px-5" data-id="element-224">
      <div className="max-w-lg mx-auto text-center" data-id="element-225">
        <p className="text-[10px] font-bold tracking-[0.2em] uppercase mb-1.5" style={{
        color: '#D4AF37'
      }} data-id="element-226">
          RESEÑAS VERIFICADAS
        </p>
        <h3 className="text-base md:text-lg font-bold text-white leading-snug mb-4" data-id="element-227">
          Lo que dicen quienes ya recuperaron la paz en sus paseos
        </h3>

        {/* Compact Rating Box */}
        <div className="rounded-xl px-5 py-3 mx-auto max-w-[260px] shadow-[0_4px_16px_rgba(0,0,0,0.25)]" style={{
        backgroundColor: '#1A4A4A'
      }} data-id="element-228">
          <div className="flex items-center justify-center" data-id="element-229">
            <div className="flex-1 flex flex-col items-center gap-0.5" data-id="element-230">
              <span className="text-white font-black text-2xl leading-none" data-id="element-231">
                4.9
              </span>
              <div className="flex items-center gap-0.5" data-id="element-232">
                {[...Array(5)].map((_, i) => <svg key={i} className="w-3 h-3" viewBox="0 0 20 20" fill="#22C55E" data-id="element-233">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-234" />
                  </svg>)}
              </div>
            </div>
            <div className="w-px h-8 bg-white/15 mx-3" data-id="element-235"></div>
            <div className="flex-1 flex flex-col items-center gap-0.5" data-id="element-236">
              <span className="text-white font-black text-2xl leading-none" data-id="element-237">
                5.700+
              </span>
              <span className="text-white/40 text-[9px] font-bold tracking-widest uppercase" data-id="element-238">
                DUEÑOS
              </span>
            </div>
          </div>
        </div>

        <p className="text-white/25 text-[10px] mt-2" data-id="element-239">
          Basado en encuestas de satisfacción en España (2025-2026)
        </p>
      </div>
    </div>;
}